/**
 * Keys de i18n para formularios de renovación y cancelación académica.
 * Los textos viven en src/locales/en.json (fallback) y el CMS puede sobrescribirlos.
 */

export const ACADEMIC_FORM_SHARED_TEXTS = {
  questionMainReason: 'account.form.shared.question_main_reason',
  questionUsageFrequency: 'account.form.shared.question_usage_frequency',
  questionUsefulness: 'account.form.shared.question_usefulness',
  questionSuggestions: 'account.form.shared.question_suggestions',
  questionAccess: 'account.form.shared.question_access',
  selectFrequencyPlaceholder: 'account.form.shared.select_frequency_placeholder',
  selectAccessPlaceholder: 'account.form.shared.select_access_placeholder',
  suggestionsPlaceholder: 'account.form.shared.suggestions_placeholder',
  errorMainReason: 'account.form.shared.error_main_reason',
  errorUsageFrequency: 'account.form.shared.error_usage_frequency',
  errorUsefulness: 'account.form.shared.error_usefulness',
  errorAccess: 'account.form.shared.error_access',
  btnCancel: 'account.form.shared.btn_cancel',
  btnSubmitting: 'account.form.shared.btn_submitting',
  drugTarget: 'account.form.shared.usage_drugTarget',
  genomicVariant: 'account.form.shared.usage_genomicVariant',
  biomarker: 'account.form.shared.usage_biomarker',
  instructors: 'account.form.shared.usage_instructors',
  students: 'account.form.shared.usage_students',
  bioinformatics: 'account.form.usage_bioinformatics',
  other: 'account.form.usage_other',
  otherSpecifyPlaceholder: 'account.form.shared.other_specify_placeholder',
  errorApplicationTypeOther: 'account.form.shared.error_application_type_other',
  usefulnessNotUseful: 'account.form.shared.usefulness_1',
  usefulnessSlightly: 'account.form.shared.usefulness_2',
  usefulnessModerately: 'account.form.shared.usefulness_3',
  usefulnessVery: 'account.form.shared.usefulness_4',
  usefulnessExtremely: 'account.form.shared.usefulness_5',
  webInterface: 'account.form.shared.web_interface',
  restApi: 'account.form.shared.rest_api',
  r2Package: 'account.form.shared.r2_package',
  cytoscape: 'account.form.shared.cytoscape',
  aida: 'account.form.shared.aida',
  helpSelectOne: 'account.form.shared.help_select_one',
  helpSelectAll: 'account.form.shared.help_select_all',
  questionMarketingConsent: 'account.form.shared.question_marketing_consent',
  marketingConsentYes: 'account.form.shared.marketing_consent_yes',
  marketingConsentNo: 'account.form.shared.marketing_consent_no',
  errorMarketingConsent: 'account.form.shared.error_marketing_consent',
} as const;

export const ACADEMIC_FORM_RENEWAL_TEXTS = {
  title: 'account.form.renewal.title',
  description: 'account.form.renewal.description',
  btnSubmit: 'account.form.renewal.btn_submit',
  mainReasonDataQuality: 'account.form.renewal.main_reason_data_quality',
  mainReasonEssential: 'account.form.renewal.main_reason_essential',
  mainReasonRegularUse: 'account.form.renewal.main_reason_regular',
  mainReasonInstitutional: 'account.form.renewal.main_reason_institutional',
  mainReasonOther: 'account.form.renewal.main_reason_other',
} as const;

export const ACADEMIC_FORM_CANCELLATION_TEXTS = {
  title: 'account.form.cancellation.title',
  description: 'account.form.cancellation.description',
  btnSubmit: 'account.form.cancellation.btn_submit',
  mainReasonNoLongerNeed: 'account.form.cancellation.main_reason_no_longer',
  mainReasonDidNotUse: 'account.form.cancellation.main_reason_did_not_use',
  mainReasonDataCoverage: 'account.form.cancellation.main_reason_data_coverage',
  mainReasonPricing: 'account.form.cancellation.main_reason_pricing',
  mainReasonTechnical: 'account.form.cancellation.main_reason_technical',
  mainReasonOther: 'account.form.cancellation.main_reason_other',
} as const;
